/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

const ACLTabStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
  },
  tabs: {
    marginBottom: '20px',
    minHeight: '40px',
    flex: '0 0 auto',
    '& .MuiTab-root': {
      '&.Mui-selected': {
        borderColor: '#EEEEEE',
        background: 'transparent',
      },
    },
  },
}));

export { ACLTabStyles };
